<head>
<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <br />
  <div class="row">
    <span><h2>Cadastro de Atendente</h2></span>
  </div>

  <div class="row">
    <div class="col-md-2">
      <label for="cpf">CPF do Atendente</label><br />
      <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" ref="cpf" v-model="form.cpf" id="cpf" />
    </div>
    <div class="col-4">
      <label for="nome">Nome da Atendente</label><br />
      <input type="text" class="form-control form-input-component" v-model="form.nome" id="nome" />
    </div>
  </div>
  <br />

  <a-divider type="horizontal">Relação de Médicos que o Atendente auxilia <a class="fas fa-user-plus fa-lg" title="Vincular novo Médico ao Atendente" @click="selecionarProfissional" /> </a-divider>

  <b></b>
  <a-table :dataSource="form.medicos" :columns="columns">
    <template #action="{ record }">
      <a @click="excluirMedico(record)"><i class="fas fa-trash icon-trash"></i></a>
    </template>
  </a-table>
  <a-divider type="horizontal" />
  <div class="row">
    <div class="col-2">
      <button type="button" class="btn btn-primary" @click="saveAndContinue" style="margin-right: 10px">Salvar</button>
    </div>
  </div>

  <Dialog
    header="Pesquisa Médico"
    v-model:visible="showPesquisaMedico"
    style="
       {
        width: 60vw;
        backgroundcolor: #dcdeff;
      }
    "
    id="pesquisarMedicos"
  >
    <a-table :dataSource="listaMedicosPesquisados" :columns="columns" :key="id">
      <template #action="{ record }">
        <a @click="adicionarMedico(record)" title="Vincular"> <i class="fa-solid fa-link"></i></a>
      </template>
    </a-table>
  </Dialog>
</template>

<script>
import { getProfissional, getProfissionalByCpf } from '@/components/service/profissionalService';
import { openNotification, typesNotification } from '@/utils/notifications';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { createSecretaria, getSecretariaById } from '@/components/service/secretariasService';

export default {
  name: 'FormManterSecretaria',
  setup() {
    return {};
  },
  data() {
    return {
      submitted: false,
      v$: useVuelidate(),
      listaMedicos: [],
      showPesquisaMedico: false,
      listaMedicosPesquisados: undefined,
      form: {
        id: undefined,
        cpf: undefined,
        nome: undefined,
        medicos: [],
      },
      columns: [
        {
          title: 'CPF',
          dataIndex: 'cpf',
          key: 'cpf',
        },
        {
          title: 'Nome',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'Especialidade',
          dataIndex: 'especialidade.nome',
          key: 'especialidade.id',
        },
        {
          title: 'Ação',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  validations() {
    return {
      form: {
        cpf: {
          required,
        },
        nome: {
          required,
        },
      },
    };
  },
  methods: {
    async excluirMedico(record) {
      const index = this.form.medicos.findIndex((object) => {
        return object.id === record.id;
      });
      this.form.medicos.splice(index, 1);
    },
    async selecionarProfissional() {
      getProfissional()
        .then((r) => {
          this.listaMedicosPesquisados = r.data.profissionais;
        })
        .catch((error) => {
          openNotification(typesNotification.error, 'Não foi possível listar todos os profissionais cadastrados!');
          console.log(error);
        });
      this.showPesquisaMedico = true;
    },
    async adicionarMedico(record) {
      getProfissionalByCpf(record.cpf)
        .then((r) => {
          let medico = {
            id: r.data.id,
            cpf: r.data.cpf,
            nome: r.data.nome,
            especialidade: {
              id: r.data.especialidade.id,
              nome: r.data.especialidade.nome,
            },
          };
          this.form.medicos.push(medico);
        })
        .catch((error) => {
          openNotification(typesNotification.error, 'Não foi possível encontrar o médico com o CPF Informado!');
          console.log(error);
        });

      this.showPesquisaMedico = false;
    },
    atualizarTabela(idSecretaria) {
      getSecretariaById(idSecretaria).then((rs) => {
        this.form = rs.data;
        document.getElementById('cpf').disabled = true;
        document.getElementById('nome').disabled = true;
      });
    },
    async saveAndContinue() {
      //this.v$.$validate()
      if (this.v$.$error) {
        this.submitted = true;
        openNotification(typesNotification.error, 'Informe os campos obrigatórios');
      } else {
        await createSecretaria(this.form).then((r) => {
          let retorno = r.data;
          this.form.id = retorno.id;
          this.form.medicos = retorno.medicos;
          this.submitted = true;
          document.getElementById('cpf').disabled = true;
          document.getElementById('nome').disabled = true;
          openNotification(typesNotification.success, 'Dados salvos com sucesso.');
        });
      }
    },
  },
  created() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id;
      this.atualizarTabela(this.form.id);
    }
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}
</style>
